export const ESTIMATED_SEARCH_VOLUME_ID = 'estimated_exact_search_volume'
export const RELATIVE_VALUE_SCORE_ID = 'relative_value_score'
export const RELEVANCY_SCORE_ID = 'relevancy_score'
export const EASE_TO_RANK_ID = 'ease_to_rank'
export const MONTHLY_TREND_ID = 'monthly_trend'

export const SOV_KEYWORD_TEXT_ID = 'keyword__text'
export const TRACK_SOV_KEYWORD_ID = 'track_sov_keyword'
export const KEYWORD_RESEARCH_LIST_ITEM_ACTIONS_ID = 'keyword_list_item_actions'
